import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/contacts/whatsapp.svg'
import _imports_1 from '@/assets/contacts/instagram.svg'
import _imports_2 from '@/assets/contacts/facebook.svg'
import _imports_3 from '@/assets/contacts/phone.svg'
import _imports_4 from '@/assets/contacts/mail.svg'
import _imports_5 from '@/assets/coming-soon_1200x721.webp'
import _imports_6 from '@/assets/coming-soon_1600x961.webp'
import _imports_7 from '@/assets/coming-soon_800x480.webp'
import _imports_8 from '@/assets/coming-soon_500x300.webp'
import _imports_9 from '@/assets/coming-soon_380x228.webp'


const _withScopeId = n => (_pushScopeId("data-v-235842ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_6 + ' 1600w, ' + _imports_5 + ' 1200w, ' + _imports_7 + ' 800w, ' + _imports_8 + ' 500w, ' + _imports_9 + ' 380w'
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div data-v-235842ea><div class=\"wrapper\" data-v-235842ea><div class=\"contacts\" data-v-235842ea><div class=\"socials\" data-v-235842ea><a target=\"_blank\" href=\"https://wa.me/351938451878\" data-v-235842ea><img src=\"" + _imports_0 + "\" alt=\"Whatsapp\" data-v-235842ea></a><a target=\"_blank\" href=\"https://www.instagram.com/wiskers.pet.services/\" data-v-235842ea><img src=\"" + _imports_1 + "\" alt=\"Instagram\" data-v-235842ea></a><a target=\"_blank\" href=\"https://www.facebook.com/wiskers.pet.services/\" data-v-235842ea><img src=\"" + _imports_2 + "\" alt=\"Facebook\" data-v-235842ea></a></div><div class=\"phones xl\" data-v-235842ea><a target=\"_blank\" href=\"tel:+351936363965\" data-v-235842ea><img src=\"" + _imports_3 + "\" alt=\"Phone\" data-v-235842ea>+351 936363965</a><a target=\"_blank\" href=\"tel:+351938451878\" data-v-235842ea><img src=\"" + _imports_3 + "\" alt=\"Phone\" data-v-235842ea>+351 938451878</a><a target=\"_blank\" href=\"mailto:geral@wiskers.pet\" data-v-235842ea><img src=\"" + _imports_4 + "\" alt=\"Mail\" data-v-235842ea><span class=\"break-word\" data-v-235842ea>geral@wiskers.pet</span></a></div></div><img class=\"hero__img\" srcset=\"" + _hoisted_1 + "\" sizes=\"\n            (min-width: 1120px) 800px,\n            (min-width: 920px) calc(78.89vw - 68px),\n            (min-width: 880px) 800px,\n            calc(95vw - 17px)\n          \" src=\"" + _imports_5 + "\" alt=\"Coming Soon\" data-v-235842ea></div></div><div class=\"phones sm\" data-v-235842ea><a target=\"_blank\" href=\"tel:+351936363965\" data-v-235842ea><img src=\"" + _imports_3 + "\" alt=\"Phone\" data-v-235842ea>+351 936363965</a><a target=\"_blank\" href=\"tel:+351938451878\" data-v-235842ea><img src=\"" + _imports_3 + "\" alt=\"Phone\" data-v-235842ea>+351 938451878</a><a target=\"_blank\" href=\"mailto:geral@wiskers.pet\" data-v-235842ea><img src=\"" + _imports_4 + "\" alt=\"Mail\" data-v-235842ea><span class=\"break-word\" data-v-235842ea>geral@wiskers.pet</span></a></div>", 2)

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ComingSoonView',
  setup(__props) {

let eventDate = new Date("Apr 17, 2024 00:00:00");
let countdown = ref(["12", "34", "56"]);
let timeLeft = 2;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
let countdownExpired = false;

function countdownTimer() {
  if (timeLeft > 0) {
    setTimeout(() => {
      updateCountdown();
      countdownTimer();
    }, 5000);
  } else {
    countdownExpired = true;
  }
}

function updateCountdown() {
  let localEventDate = eventDate.getTime();
  let currentDate = new Date().getTime();

  let localTimeLeft = localEventDate - currentDate;
  timeLeft = localTimeLeft;

  let days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  let hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let daysString: any = days < 10 ? "0" + String(days) : String(days);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let hoursString: any = hours < 10 ? "0" + String(hours) : String(hours);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let minutesString: any =
    minutes < 10 ? "0" + String(minutes) : String(minutes);

  countdown.value[0] = daysString;
  countdown.value[1] = hoursString;
  countdown.value[2] = minutesString;
}

countdownTimer();
updateCountdown();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t("coming-soon.title")), 1),
      _createElementVNode("h2", null, _toDisplayString(_unref(countdown)[0]) + "d " + _toDisplayString(_unref(countdown)[1]) + "h " + _toDisplayString(_unref(countdown)[2]) + "m", 1)
    ]),
    _hoisted_3
  ]))
}
}

})